import { useAuth } from 'hooks/useAuth';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { exportTemplateSelectors as selectors } from 'reducers/exportTemplate/reducer';
import { meetsColumnRequirements } from 'utils/helpers/license';

/**
 * Returns the count of metadata columns available to the current user, applying
 * licence requirements via {@link meetsColumnRequirements}. Used by the export
 * templates dropdown for the SciLeads-default option, so the displayed count
 * matches what the user can actually export (e.g. 198 vs 204 for academic-only
 * users who lack VC funding fields).
 *
 * @returns {number}
 */
export const useAvailableFieldsCount = () => {
  const { hasLicense } = useAuth();
  const sheetMetadata = useSelector(selectors.getSheetMetadata);

  return useMemo(() => {
    if (!sheetMetadata) return 0;
    let count = 0;
    for (const sheet of sheetMetadata) {
      for (const col of sheet.columns) {
        if (meetsColumnRequirements(col.requirements, hasLicense)) count++;
      }
    }
    return count;
  }, [sheetMetadata, hasLicense]);
};
